import PrivateBusPricingResource from "./privateBusPricing.resource";

const privateBusPricingModule = angular
  .module("app.resources.privateBusPricing", [])
  .service("PrivateBusPricing", PrivateBusPricingResource);

export default privateBusPricingModule;



// WEBPACK FOOTER //
// ./src/resources/privateBusPricing/privateBusPricing.module.js